<template>
    <div class="card-view">
        <WeatherCard class="weather-card" :cardId="mobileCardId" cardSize="mobile" />
    </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import WeatherCard from '@/components/common/WeatherCard.vue'

export default {
    name: 'CardViewM',
    components: {
        WeatherCard,
    },
    computed: {
        ...mapState({
            mobileCardId: (state) => state.mobileCardId,
        }),
    },
    methods: {
        ...mapMutations(['setMobileCardId']),
    },
    created() {
        this.setMobileCardId('solar')
    },
}
</script>

<style lang="scss" scoped>
.card-view {
    @media (orientation: portrait) {
        width: 90%;
        margin: 1rem 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    @media (orientation: landscape) {
        width: 55vw;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
}
</style>
